import React, { useState,useEffect } from 'react';
import { Row, Col, ProgressBar, Dropdown } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { DeleteIcon, EclipseIcon, EditIcon, ViewIcon } from '../../../utils/FontIcon';
import { getOverAllRating, useImageWithFallback, formatDate } from '../../../utils/utils';
import { useLogin } from '../../../context/LoginContext';
import {useCourse} from '../../../context/CourseContext'
import { ShowMoreText } from '../../shared';

function CourseAction({ handelAction, course }) {
  const [show, setShow] = useState(false);
  const handleToggle = (isOpen) => setShow(isOpen);
  const handleItemClick = (e, action) => {
    e.preventDefault();
    e.stopPropagation();
    handelAction(e, action, course);
    setShow(false);
  };
  const { status } = course;
  return (
    <Dropdown show={show} onToggle={handleToggle} title='More Options'>
      <Dropdown.Toggle
        as="span"
        bsPrefix="dropdown-toggle-no-caret"
        style={{
          background: 'none',
          border: 'none',
          boxShadow: 'none',
          padding: '5px',
          cursor: 'pointer',
        }}>
        <EclipseIcon />
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: '130px' }}>
        <Dropdown.Item onClick={e => handleItemClick(e, 'view')}>
          <ViewIcon /> View
        </Dropdown.Item>
        {status !== 'published' && (
          <Dropdown.Item onClick={e => handleItemClick(e, 'edit')}>
            <EditIcon /> Edit
          </Dropdown.Item>
        )}
        {status !== 'published' && (
          <Dropdown.Item onClick={e => handleItemClick(e, 'delete')}>
            <DeleteIcon /> Delete
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
function CourseCard({ course, handelAction = () => { }}) {

  const { user } = useLogin();
  const { HandelAddreviewRatting } = useCourse();
  const fallbackUrl = '/lms/img/no-video-icon.png';
  const thumbnailUrl = course?.thumbnailUrl ?? fallbackUrl;
  const description = course.description ? course.description : 'No description available.';
  const statusClass = course.status === 'draft' ? 'pending' : course.status === 'rejected' ? 'reject' : course.status === 'published' ? 'approve' : '';
  const title = course.title ? course.title : 'No Title available.';
  const accessModeClass = course?.accessMode === 'public' ? 'public' : 'mandate';
  const [imgSrc, handleImgError] = useImageWithFallback(thumbnailUrl, fallbackUrl);
  const [hovered, setHovered] = useState(false);
  const renderTitle = () => {
    if (hovered) {
      return <span>{title}</span>;
    }
    return <ShowMoreText text={title} previewLength={20} hasbutton={false} />;
  };
  const renderDescription = () => {
    if (hovered) {
      return <span>{description}</span>;
    }
    return <ShowMoreText text={description} previewLength={35} hasbutton={false} />;
  };
  return (
    <Card
      className={user?.selectedRole === 'viewer' ? 'course-listing-learner' : 'course-listing'}
      onMouseEnter={ () => setHovered(true) }
      onMouseLeave={() => setHovered(false)}
      onClick={user?.selectedRole === 'viewer' ? (e) => handelAction(e, 'view', course) : undefined}
    >
      <div className='course-thumbnail' onClick={user?.selectedRole !== 'viewer' ? (e) => handelAction(e, 'view', course) : undefined}>
        <Card.Img variant="top" className='img-fluid' style={{ height: '100%' }} alt='Course Thumbnail' src={imgSrc} onError={handleImgError} />
        <div className='course-thumbnail-hover'/>
        {course?.progressPercent == 0 && (<small className="newly-added-badge">New</small>)}
      </div>
      <Card.Body className='course-card-body'>
        {user?.selectedRole !== 'viewer' ? (
          <small className={`course-status ${statusClass}`}>{course?.status}</small>
        ) : (
          <>
            <small className={`course-status ${accessModeClass}`}>{course?.accessMode}</small>
          </>
        )}
        <Card.Title className='mbtm0'>
          <Row className='p-relative align-items-center'>
            <Col xs={user?.selectedRole !== 'viewer' ? 10 : 12}>
              <h6 className='mbtm0'>{renderTitle()}</h6>
            </Col>
            {user?.selectedRole !== 'viewer' && (
            <Col lg={2} xs={2} className='text-end'>
              <CourseAction handelAction={handelAction} course={course} />
            </Col>
            )}
          </Row>
        </Card.Title>
        <Card.Text className='mb-0'>
          {renderDescription()}
        </Card.Text>
        {user?.selectedRole === 'viewer' && (
          <Row className='align-items-center'>
            <Col md={12} className='mb-2'>
              <span className='d-block mt-1 start-info'>Start: {course?.usrCourseProgress?.createdAt ? formatDate(course?.usrCourseProgress?.createdAt, false) : 'Not Start'}</span>
              {course?.usrCourseProgress?.lastAccessed && (
                <span className='d-block last-view-info'>{course.progressPercent >= 100 ? 'Completed on:' : 'Last Access:'} {formatDate(course?.usrCourseProgress?.lastAccessed, false)}</span>
              )}
            </Col>
            <Col md={12}>
              <ProgressBar
                now={course?.progressPercent || 0}
                style={{ height: '3px', background: '#e9ecef' }}
                variant="dark"
              />
            </Col>
            <Col md={6}>
              <small className='d-block' style={{ paddingTop: '3px' }}>{`${course?.progressPercent || 0}%  complete`}</small>
            </Col>
            <Col md={6} className='text-end' onClick={HandelAddreviewRatting.bind(this, true, course?.title, course?.ratingdata?.rating, course?._id)}>
              {getOverAllRating(course?.ratingdata?.rating || 0)}
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}

export default CourseCard;